const ENVIRONMENT = 'PROD';

export { ENVIRONMENT };

const CONCERN_FHIR_IDs = {
  "POC": "tisVYNNjKpn3YB8XXOBYkcA0",
  "TST": "taWa291Zsvg0vtoPaXsLR7w0",
  "PROD": "taWa291Zsvg0vtoPaXsLR7w0"
};

export { CONCERN_FHIR_IDs };


// const MAR_URLs = {
//   "POC": "https://icfg-np.et1089.epichosted.com/Interconnect-OAuth2-POC/api/epic/2014/Clinical/Patient/GETMEDICATIONADMINISTRATIONHISTORY/MedicationAdministration",
//   "PROD": "https://icfg.et1089.epichosted.com/Interconnect-OAuth2-PRD/api/epic/2014/Clinical/Patient/GETMEDICATIONADMINISTRATIONHISTORY/MedicationAdministration"
// };

// export { MAR_URLs };
